import { gql } from '@apollo/client'

export const VOYAGE_FIELDS = gql`
  fragment VoyageFields on Voyage {
    boardingMethod
    debarkDate
    debarkPortCode
    embarkDate
    embarkPortCode
    isActive
    isDeleted
    isMociEnabled
    isOciEnabled
    isVoyageRollover
    name
    number
    preSaveEnabled
    sailingPackageCode
    shipCode
    id
    itineraries {
      arrivalTime
      departureTime
      gangwayClosingTime
      gangwayOpeningTime
      isSeaDay
      itineraryDay
      portCode
      portType
      voyageId
      id
    }
  }
`

export const GET_VOYAGE_BY_ID_QUERY = gql`
  query Voyage($voyageId: ID!) {
    voyage(id: $voyageId) {
      ...VoyageFields
    }
  }
  ${VOYAGE_FIELDS}
`

export const UPDATE_SLOTS_MUTATION = gql`
  mutation UpdateGuestBoardingNumbers($input: GuestBoardingNumberUpdateInput!) {
    updateGuestBoardingNumbers(input: $input) {
      id
    }
  }
`

export const UPDATE_BOARDING_NUMBER_MUTATION = gql`
  mutation UpdateBoardingNumbers($input: BoardingNumberUpdateInput!) {
    updateBoardingNumbers(input: $input) {
      id
    }
  }
`

export const GET_SLOT_QUERY = gql`
  query SearchBoardingNumber($filter: BoradingNumberSearchFilter!) {
    searchBoardingNumber(filter: $filter) {
      id
      assignedGuestCount
      boardingNumber
      boardingSlotEndTime
      boardingSlotStartTime
      checkedInGuestCount
      effectiveFromDate
      effectiveToDate
      expectedGuestCount
      isActive
      isDeleted
      isEnabled
      isReserved
      onBoardedGuestCount
      slotNumber
      activeSlotTime
      offset
      shipCode
      voyageNumber
    }
  }
`
export const GET_BOARDING_SLOT_MASTER_QUERY = gql`
  query SearchBoardingNumberMasterData(
    $filter: BoardingNumberMasterDataFilter!
  ) {
    searchBoardingNumberMasterData(filter: $filter) {
      effectiveFromDate
      effectiveToDate
      boardingNumbers {
        id
        boardingNumber
        boardingSlotStartTime
        boardingSlotEndTime
        effectiveFromDate
        effectiveToDate
        expectedGuestCount
        isActive
        isDeleted
        isEnabled
        isReserved
        shipCode
        slotNumber
      }
    }
  }
`
